import styles from './styles.module.css';

function Footer() {
    return (
        <footer className={styles.footer_container} >
            <h1 className={styles.text} >Built By Mustafa Rahman</h1>
        </footer>
    )
};

export default Footer;